import React, { useCallback, useEffect, useState } from 'react'
import './Login.css'
import { loginService } from '../../../Services/Connexion/LoginService'
import { useCookies } from 'react-cookie'
import { Identifiant } from '../../../Models/Identifiant/IdentifiantModels'
import { Link, useNavigate } from "react-router";

//test material ui
import { FormControl, InputAdornment, InputBase, Box, IconButton, Button } from '@mui/material'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { EnteteLogin } from '../../Entete/Login/EnteteLogin'

export function Login(props: {
  setInterfaceNumber?: any
  setConnecter?: any
  isAdmin?: boolean
  setIsAdmin?: any
}){
  
  //attributes
  const [showPassword, setShowPassword] = useState(false);
  const [erreurConnection, setErreurConnection] = useState<number | null>(null);
  const setCookie = useCookies(['token'])[1];
  let navigate = useNavigate();

  //
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  //methods and actions about logging
  const setInterface = useCallback((user:Identifiant)=>{
      if (user.role === 'ROLE_ADMIN') {
        navigate("/admin");
      } else {
        navigate("/accueil");
      }
  },[navigate]);

  const getIdentifiantConnect = useCallback(async (token:any, login:string)=>{
    const identifiant = await loginService().getIdentifiant(token, login);
    switch(identifiant){
      case 404:
        setErreurConnection(404);
        break;
      default:
        setInterface(identifiant);
    }
  },[setInterface])

  const connection = useCallback(async (id:string, pass:string)=>{
    const token = await loginService().getTokenConnection(id, pass);
    switch(token){
      case 1 :{
        setErreurConnection(1)
        break;
      }
      case 400 :{
        setErreurConnection(400)
        break;
      }
      case 401 :{
        setErreurConnection(401)
        break;
      }
      default:{
        let expireDate:Date = new Date();
        expireDate.setDate(expireDate.getDate()+7); //date d'expriation se place dans 7 jours
        setCookie('token', token, {path:'/', expires:expireDate})
        await getIdentifiantConnect(token, id)
        break;
      }
    }
  },[getIdentifiantConnect, setCookie])

  /**
   * Mise en place de la taille correspondante pour interface
  */
  useEffect(()=>{
    document.documentElement.style.setProperty(
      '--interface-width-pourcentage',
      '55%',
    );

    document.documentElement.style.setProperty(
      '--interface-height-pourcentage',
      '70%',
    );
  },[])


  function handleLogin(e:any){
    // Prevent the browser from reloading the page
    e.preventDefault();
    // Read the form data
    const form = e.target;
    const formData = new FormData(form);
    const formJson = Object.fromEntries(formData.entries()); //transforme les données du form en données JSON pour travailler avec
    const id = formJson['identifiant'].toString()
    const pass = formJson['mot_passe'].toString()
    connection(id, pass)
    
  }

  return (
    <>
      <div className='container-entete'>
        <EnteteLogin/>
      </div>
      <div className='container-interface'>
        <div className='Interface'>
          <Box component="section" sx={{ 
            p: '5%', 
            width:"100%", 
            alignItems:'center'
          }}>
            <div className='Login-text'>
              <p>Identification</p>
              <p className='Login-text-espace-abonne'>Espace Abonné</p>
            </div>
            <form action="post" onSubmit={handleLogin}>
              <div className='Login-container-textarea'>
                <div className='Login-textarea'>
                  <p>Identifiant</p>
                  <FormControl sx={{width: '100%'}} variant="outlined" required>
                    <div className="input_mui">
                    <InputBase
                        id="identifier"
                        name='identifiant'
                        sx={{
                          width:'100%'
                        }}
                        autoFocus
                      />
                    </div>
                  </FormControl>
                </div>
                <div className='Login-textarea'>
                  <p>Mot de passe</p>
                  <FormControl sx={{width: '100%'}} variant="outlined" required>
                    {/* <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel> */}
                    {/* <InputLabel htmlFor="filled-adornment-password">Password</InputLabel> */}
                    <div className="input_mui">
                      <InputBase
                        id="password"
                        name='mot_passe'
                        type={showPassword ? 'text' : 'password'}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showPassword ? 'hide the password' : 'display the password'
                              }
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              onMouseUp={handleMouseUpPassword}
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        }
                        sx={{
                          width:'100%'
                        }}
                      />
                    </div>
                  </FormControl>
                </div>
                {erreurConnection === 401 ? (
                  <p>Mauvais identifiant ou mot de passe</p>
                ) : erreurConnection === 400 ? (
                  <p>Veuillez renseigner un identifiant ou un mot de passe</p>
                ) : erreurConnection === 404 ?(
                  <p>Identifiant introuvable</p>
                ) : erreurConnection === 1 ?(
                  <p>Erreur requête de connexion</p>
                ): null}
              </div>
              <div className='Login-button'>
                <Button 
                  type='submit'
                  variant='contained'
                  className='Login-button-se-connecter'
                  sx={{
                    backgroundColor:'var(--violet)',
                    border:'2px solid var(--violet)'
                  }}
                >SE CONNECTER</Button>
                <Link style={{textDecoration:'none'}} to="/helpLogin">
                  <div
                    className='Login-button-mdp-oublié'
                  >
                    Mot de passe ou Identifiant oublié ?
                  </div>
                </Link>
              </div>
            </form>
          </Box>
        </div>
      </div>
    </>
  )
}
